import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch, apiFetch } from '../modules/utility';

const apiBase = 'emailReadyDriverShift';

const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			dispatch,
			callback,
		});
	};
};

const get = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	const emailReadyDriverShiftId = ownProps.emailReadyDriverShiftId
		? ownProps.emailReadyDriverShiftId
		: _.get(ownProps, ['match', 'params', 'emailReadyDriverShiftId']);
	const emailReadyDriverShift = _.get(state.maps, [
		'emailReadyDriverShift',
		emailReadyDriverShiftId,
	]);

	let emailReadyDriverShifts = [];
	if (state.lists.emailReadyDriverShiftIds) {
		emailReadyDriverShifts = _.map(
			state.lists.emailReadyDriverShiftIds,
			(id) => state.maps.emailReadyDriverShift[id]
		);
	}

	return {
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		emailReadyDriverShift,
		emailReadyDriverShifts,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getEmailReadyDriverShift: get,
			searchEmailReadyDriverShifts: search,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
